import { render, staticRenderFns } from "./DashboardChat.vue?vue&type=template&id=cf8598c2"
import script from "./DashboardChat.vue?vue&type=script&lang=js"
export * from "./DashboardChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports